import axios from 'axios';
import { get} from "lodash";

import { CLIENT_ID, API_URL } from "../Data/Constants";

export function setAxiosDefaults() {
    axios.defaults.baseURL = API_URL;

    axios.interceptors.response.use(function (response) {
        return response.data;
    }, function (error) {
        if (get(error, "response.status") === 403)
            window.location.pathname = "/forbidden";
        if (get(error, "response.status") === 401) {
            //redirectToLoginPage(window.location.pathname);
            window.location = "/unauthorized?redirectTo="+window.location.pathname;
        }
        return Promise.reject(get(error, "response.data", "Ismeretlen hiba."));
    });
}

export function setAuthorizationHeader(token) {
    if (token) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete axios.defaults.headers.common['Authorization'];
    }
}

export function redirectToLoginPage(redirectUrl) {
    const state = {
        nonce: makeNonce(),
        redirectUrl: redirectUrl
    };

    const stateBase64 = btoa(JSON.stringify(state));

    localStorage.setItem("state", stateBase64);

    window.location.href = `https://auth.sch.bme.hu/site/login?response_type=code&client_id=${CLIENT_ID}&state=${stateBase64}&scope=basic+displayName+mail+eduPersonEntitlement`;//+bmeunitscope`;
}

export function isStateValid(state) {
    return localStorage.getItem("state") === state;
}

function makeNonce() {
    var nonce = "";
    var possibleChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 15; i++)
        nonce += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));

    return nonce;
}